import React from "react";

/**
 * The 44px strip along the bottom of the Workbench. The shell renders it only
 * when a route supplies a `statusBar` slot; screens build the strip out of
 * <StatusCell> so every page's bottom line reads the same way.
 *
 * StatusCell renders a value the backend already computed — it never derives
 * or re-formats money itself.
 */

export function StatusCell({
  label,
  value,
  emphasis = false,
  title,
  tone = null,
  // Survives the narrow-width cut. The strip is pinned to the bottom of the
  // viewport and cannot scroll the page along with it, so below the top bar's
  // breakpoint only essential cells stay — the next step, the build cost,
  // anything in warn tone, and the quote. Everything else is a desktop detail.
  essential = false,
}) {
  return (
    <div
      className={`wb-stat${emphasis ? " wb-stat--emphasis" : ""}${
        tone === "warn" ? " wb-stat--warn" : ""
      }${tone === "stale" ? " wb-stat--stale" : ""}${
        essential || tone === "warn" ? " wb-stat--essential" : ""
      }`}
      title={title}
      role={tone === "warn" ? "status" : undefined}
    >
      <span className="wb-stat__k">{label}</span>
      <span className="wb-stat__v">{value}</span>
    </div>
  );
}

function WorkbenchStatusBar({ children }) {
  if (!children) return null;
  return (
    <footer className="wb-statusbar" role="contentinfo">
      {children}
    </footer>
  );
}

export default WorkbenchStatusBar;
